import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { useI18n } from '../context/I18nContext';
import { publicApi } from '../api';
import { useApi } from '../hooks/useApi';
import { HelpCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function FAQSection({ limit }) {
  const { lang, tr } = useI18n();
  const { data } = useApi(() => publicApi.faqs(lang), [lang]);
  const list = typeof limit === 'number' ? (data || []).slice(0, limit) : (data || []);

  return (
    <section className="relative py-16 md:py-24 lg:py-28">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="grid lg:grid-cols-[420px_1fr] gap-10 lg:gap-14">
          <div>
            <div className="flex items-center gap-2 text-xs font-bold tracking-[0.3em] text-[#e4b44e]/85 mb-3">
              <HelpCircle className="w-3.5 h-3.5" /> {tr('home.faq_eyebrow', 'SIK SORULAN SORULAR')}
            </div>
            <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-black text-white leading-tight">
              {tr('home.faq_title_1', 'Merak Edilen')} <span className="gold-text">{tr('home.faq_title_2', 'Sorular')}</span>
            </h2>
            <p className="text-white/60 mt-4 leading-relaxed">{tr('home.faq_subtitle', 'Ekibimize ulaşmadan önce, en çok merak edilen sorulara buradan göz atın.')}</p>
            <div className="mt-8 p-5 rounded-2xl border border-[#e4b44e]/25 bg-[#e4b44e]/5">
              <div className="text-sm font-bold text-white mb-1">{tr('home.faq_help_title', 'Cevabı bulamadınız mı?')}</div>
              <div className="text-sm text-white/60 mb-3">{tr('home.faq_help_sub', '7/24 destek ekibimize ulaşın.')}</div>
              <Link to="/contact" className="btn-outline-gold inline-flex items-center gap-2 h-10 px-5 rounded-full text-xs font-extrabold tracking-widest">{tr('home.contact', 'İLETİŞİM')}</Link>
            </div>
          </div>

          <Accordion type="single" collapsible className="space-y-3">
            {list.map((f, i) => (
              <AccordionItem key={f.id} value={`item-${i}`} className="border border-white/8 rounded-2xl px-5 bg-white/[0.02] data-[state=open]:border-[#e4b44e]/40 data-[state=open]:bg-[#e4b44e]/5 transition">
                <AccordionTrigger className="text-left text-white hover:text-[#f4d896] hover:no-underline text-base font-semibold py-5">{f.q}</AccordionTrigger>
                <AccordionContent className="text-white/70 pb-5 leading-relaxed">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
